
import Vue from "vue";
import { Action } from "vuex-class";
import { ActionMethod } from "vuex";
import { Component, Watch, Prop } from "vue-property-decorator";
import { Route } from "vue-router";
import firebase from "firebase";
import BaseTeamCard from "@/components/widgets/BaseTeamCard.vue";
import Header from "@/components/core/Header.vue";
import Footer from "@/components/core/Footer.vue";
import Chat from "@/components/core/Chat.vue";
import AccessibilitySkipLink from "@/components/common/AccessibilitySkipLink.vue";
import Dialog from "@/components/common/Dialog/index.vue";

import "reflect-metadata";
import { firebaseEnvironmentKey } from "@/utils/FirebaseKeys";
import { eventBus } from "@/modules/EventService";

@Component({
  components: {
    Footer,
    Header,
    BaseTeamCard,
    Chat,
    AccessibilitySkipLink,
    Dialog,
  },
})
export default class App extends Vue {
  @Action getTokenChat!: ActionMethod;

  @Action setIsShowPortability!: ActionMethod;

  @Action setPromoPlan!: ActionMethod;

  @Action setIsShowSimDelivery!: ActionMethod;

  @Action getVertexParams!: ActionMethod;

  @Action getIdOrigin!: ActionMethod;

  @Action setSkeeloCompositionId!: ActionMethod;

  @Prop({ default: "" }) readonly uriChat!: string;

  showAlertMessage = false;

  get detectMob() {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i,
    ];

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }

  off = typeof process.env.VUE_APP_API_CHAT_TOKEN === "string";

  consFrame = process.env.VUE_APP_API_CHAT_FRAME;

  whatsappUrl = process.env.VUE_APP_API_WHATSAPP;

  isWhatsAppEnabled = false;

  isChatEnabled = false;

  showFooterFlag = false;

  customParentClass = "";

  hideFooterInRoutes: string[] = [
    "ForgotPassword",
    "Register",
    "Login",
    "SetPassword",
    "ResetPassword",
  ];

  @Watch("$route", {
    immediate: true,
    deep: true,
  })
  showFooter(newVal: Route): void {
    if (!newVal.name) {
      this.showFooterFlag = false;
      return;
    }
    this.showFooterFlag = !this.hideFooterInRoutes.includes(newVal.name);
    this.getParentClassName();
  }

  async getParentClassName(): Promise<void> {
    let path = this.$route.path || "";
    if (!path.length) {
      return;
    }
    path = path.replaceAll("/", " ").trim().split(" ").join("-");
    this.customParentClass = path.length ? path : "dashboard";
    if (localStorage.getItem("x-customer-id")) {
      await this.loggedIn();
    }
  }

  async loggedIn() {
    let err = false;
    const win = window as any;
    const ret = await this.getTokenChat().catch((error) => {
      err = true;
      const parseError = JSON.parse(error);
      if (this.$gtm.enabled()) {
        win.dataLayer.push({
          event: "event",
          eventCategory:
            this.$route.fullPath === "/"
              ? "claro-flex:home"
              : "claro-flex:checkout",
          eventAction: "callback:chat",
          eventLabel: "erro:".concat(
            !parseError.message ? parseError.code : parseError.message
          ),
        });
      }
    });
    if (!err) {
      this.consFrame = this.consFrame!.concat("?token=")
        .concat(ret.token)
        .concat("&origem=logado&appOrigem=Flex&nome=")
        .concat(localStorage.getItem("nome")!)
        .concat("&cpf=")
        .concat(localStorage.getItem("cpf")!)
        .concat("&email=")
        .concat(localStorage.getItem("email")!);

      if (localStorage.getItem("msisdn")) {
        this.consFrame = this.consFrame!.concat("&telefone=").concat(
          localStorage.getItem("msisdn")!
        );
      }
    }
  }

  keyListener(e: KeyboardEvent) {
    const activeElement = document.activeElement;
    const inputs = ["input", "select", "textarea"];
    if (
      e.shiftKey === true &&
      activeElement &&
      inputs.indexOf(activeElement.tagName.toLowerCase()) === -1 &&
      (e.key.toLowerCase() === "f" ||
        e.key.toLowerCase() === "t" ||
        e.key.toLowerCase() === "c" ||
        e.key.toLowerCase() === "m")
    ) {
      e.preventDefault();
      switch (e.key.toLowerCase()) {
        case "f":
          setTimeout(() => {
            document.getElementById("footer")!.scrollIntoView();
            document.getElementById("footer")!.focus();
          }, 100);
          break;
        case "t":
          setTimeout(() => {
            document.getElementById("header")!.scrollIntoView();
            document.getElementById("header")!.focus();
          }, 100);
          document.getElementById("header-logo")!.focus();
          break;
        case "c":
          setTimeout(() => {
            document.getElementById("body")!.scrollIntoView();
            document.getElementById("body")!.focus();
          }, 100);
          break;
        case "m":
          setTimeout(() => {
            document.getElementById("main")!.scrollIntoView();
            document.getElementById("main")!.focus();
          }, 100);
          break;
      }
    }
  }

  mounted() {
    window.addEventListener("keypress", this.keyListener);
    eventBus.$on("authError", (isAuthError: boolean) => {
      if (isAuthError) {
        this.showAlertMessage = true;
      }
    });
  }

  beforeDestroy() {
    window.removeEventListener("keypress", this.keyListener);
  }

  hideAlertMessage() {
    this.showAlertMessage = false;
    this.$router.push({
      name: "Home",
    });
  }

  async created() {
    const firebaseConfig = {
      apiKey: "AIzaSyDR7yGghTFp-16FQX0I4xILNP_FbB6IpDA",
      authDomain: "claroflex-prod.firebaseapp.com",
      databaseURL: "https://claroflex-prod.firebaseio.com",
      projectId: "claroflex-prod",
      storageBucket: "claroflex-prod.appspot.com",
      messagingSenderId: "244910085520",
      appId: "1:244910085520:web:ce4708a57168e878ba4f15",
      measurementId: "G-XCN7NYN1GL",
    };

    if (!firebase.apps.length) {
      firebase.initializeApp(firebaseConfig);
      firebase.analytics();
    }

    const remoteConfig = firebase.remoteConfig();

    remoteConfig.settings.minimumFetchIntervalMillis = 10000;

    await remoteConfig.fetchAndActivate();

    this.isWhatsAppEnabled = remoteConfig.getBoolean("QA_show_whatsapp");

    const showPortability = remoteConfig.getBoolean("QA_show_portability");

    if (showPortability) {
      this.$store.dispatch("setIsShowPortability", showPortability);
    }

    await this.getIdOrigin();

    this.isChatEnabled =
      remoteConfig.getBoolean("QA_show_chat") &&
      this.$router.currentRoute.name !== "NcndLink";

    const tiktok =
      (await process.env.VUE_APP_ENV) === "prod"
        ? remoteConfig.getString("tiktok").split("|")
        : remoteConfig.getString("QA_tiktok").split("|");

    await this.$store.dispatch("setTikTok", tiktok);

    const promoPlan =
      (await process.env.VUE_APP_ENV) === "prod"
        ? remoteConfig.getString("promo_plan")
        : remoteConfig.getString("QA_promo_plan");

    await this.$store.dispatch("setPromoPlan", promoPlan);

    await this.setIsShowSimDelivery();

    const firebaseKey = await firebaseEnvironmentKey("url_chat_portal");
    const skeeloCompositionIdKey = await firebaseEnvironmentKey(
      "skeelo_composition_id_portal"
    );
    const skeeloCompositionId = remoteConfig
      .getString(skeeloCompositionIdKey)
      .split("|");
    await this.setSkeeloCompositionId(skeeloCompositionId);

    this.consFrame = remoteConfig.getString(firebaseKey);

    this.getVertexParams();
  }
}
